import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";

export interface ColumnListProps {
  label: string;
  columns: string[];
  value?: string;
  onChange?: (value: string) => void;
}

export const ColumnList = (props: ColumnListProps) => {
  const { label, columns, value, onChange } = props;

  const handleChange = (value: string) => {
    if (onChange) onChange(value);
  };

  return (
    <FormControl sx={{ minWidth: 200 }}>
      <InputLabel id="column-list-label">{label}</InputLabel>
      <Select labelId="column-list-label" label={label} value={value || ""} onChange={(e) => handleChange(e.target.value)}>
        {columns?.map((column, index) => {
          return (
            <MenuItem key={index} value={column}>
              {column}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
};
